import { DashboardProvider } from "../../context/dashboard_provider";
import { CollapsableCard } from "../general/collapsable_card";
import { Box, Grid } from "@mui/material";
import React from "react";
import { ChartDivider } from "../metering_tab/chart_card";
import { LynxChart } from "../metering_tab/lynx_chart";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import { fetchMeteringActuals } from "../../scripts/api_v2/metering_client";
import { useParams } from "react-router-dom";
import useBackend from "../../hooks/use_backend";
import RangeSelector from "../range_selector/range_selector";
import { startOfDay, endOfDay, differenceInCalendarDays } from "date-fns";

export function LynxMetering({ sx, startCollapsed = false }) {
  const params = useParams();
  const backend = useBackend();
  const today = new Date();
  const [range, setRange] = React.useState({
    startDate: startOfDay(today),
    endDate: endOfDay(today),
    key: "selection",
  });

  const baseDate = range.startDate;
  const daysAfter = differenceInCalendarDays(range.endDate, range.startDate);

  let { data: actuals, isLoading: fetchingActuals } = useQuery({
    queryKey: [REACT_QUERY_KEYS.METERING_ACTUALS, backend.fetch, params.site_id, range],
    queryFn: () => fetchMeteringActuals(backend.fetch, params.site_id, baseDate, 0, daysAfter),
    refetchInterval: 30000,
  });

  let cardTitle = "Metering";
  return (
    <DashboardProvider>
      <CollapsableCard startCollapsed={startCollapsed} title={cardTitle} {...sx}>
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={2}>
          <RangeSelector range={range} setRange={setRange} singleDate />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<LynxChart metering={actuals} />}
              title="Network operator metering"
              data={actuals}
              isLoading={fetchingActuals}
            />
          </Grid>
        </Grid>
      </CollapsableCard>
    </DashboardProvider>
  );
}
